import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { runTransactionWithRetry } from './runTransactionWithRetry'

interface TransactionClientParams {
  editorSdkProxy: EditorSDK
  useTransactions: boolean
}

type AnyFunction = (...args: unknown[]) => unknown

interface TransactionClientReturn {
  wrap: <T extends AnyFunction>(fn: T) => T
}

export function TransactionClient({
  editorSdkProxy,
  useTransactions,
}: TransactionClientParams): TransactionClientReturn {
  const wrap = <T extends AnyFunction>(fn: T): T =>
    useTransactions
      ? (((...args: Parameters<T>) =>
          runTransactionWithRetry(editorSdkProxy, () => fn(...args))) as T)
      : fn

  return { wrap }
}
